import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import OrderRefundComponent from "./component";
import { toastr } from "react-redux-toastr";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setLoading } from "../OrdersList/actions";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

const OrdersRefundContainer = (props) => {
  const { orderid } = useParams();
  const navigate = useNavigate();
  const { pg_name, id, source } = useParams();

  const [loading, setLoading] = useState(true);
  const [refundOrderId, setRefundOrderId] = useState("");
  const [refundOrderAmount, setRefundOrderAmount] = useState("");
  const [refundReason, setRefundReason] = useState("");
  const [refundSource, setRefundSource] = useState('');
  const [orderStatus, setOrderStatus] = useState('')

  const [showHistory, setShowHistory] = useState(false);

  const [historyData, setHistoryData] = useState([]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      orderRefundApi();
    }
  };

  const handleRefundOrderId = (e) => {
    setRefundOrderId(e.target.value);
  };

  const handleRefundOrderAmount = (e) => {
    const decimalValue = parseFloat(e.target.value);
    setRefundOrderAmount(decimalValue);
  };

  const handleRefundReason = (e) => {
    setRefundReason(e.target.value);
  };

  const handleRefundSourceChange = (e) => {
    setRefundSource(e.target.value);
  };

  const orderRefundApi = () => {
    if (!refundOrderAmount) {
      toastr.error("Please Enter All Details to Process the Refund");
      return;
    }

    const isValidOrderAmount = (amount) => {
      return /^\d+(?:\.\d{0,2})?$/.test(amount);
    };

    if (!isValidOrderAmount(refundOrderAmount)) {
      toastr.warning("Please enter a valid refund amount");
      return;
    }

    if (refundReason === "") {
      toastr.warning("Please enter a valid reason to process the Refund");
      return;
    }
    if (pg_name === "RAZORPAY" && !refundSource) {
      toastr.warning("Please select a refund mode");
      return;
    }

    const payload = {
      pgName: pg_name,
      orderId: id,
      refundAmount: parseFloat(refundOrderAmount),
      reason: refundReason,
      refundSource: refundSource
    };

    props.getDataFromAPI(
      `/partner/api/v1/wallet/bankrefund`,
      "POST",
      payload,
      (response) => {
        setRefundOrderId("");
        setRefundOrderAmount("");
        setRefundReason("");
        toastr.success("Refund Processed!");
        navigate(-1);
      },
      (err) => {
        console.log("error1", err.message)
        toastr.error(`${"Error", err.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      }
    );
  };

  useEffect(() => {
    fetchOrderStatus();
  }, []);
  const fetchOrderStatus = () => {
    setLoading(true);

    return props.getDataFromAPI(
      `/partner/api/v2/payment/refund/${id}/status`,
      "GET",
      undefined,
      (response) => {
        console.log("amountrefund", response.refundDetailInfoList)
        setOrderStatus(response);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        toastr.error(`${err.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      },
      true
    );
  };

  const fetchRefundHistory = () => {
    setLoading(true);

    return props.getDataFromAPI(
      `/partner/api/v2/api/bankRefund/history/${id}`,
      "GET",
      undefined,
      (response) => {
        console.log("history", response.refundHistory)
        setHistoryData(response.refundHistory || []);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        toastr.error(`${err.status.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      },
      true
    );
  };

  

  const toggleHistory = () => {
    if (!showHistory && historyData.length === 0) {
      fetchRefundHistory();
    }
    setShowHistory(!showHistory);
  };


  const handleRevok = () => {
    props.getDataFromAPI(
      `/partner/api/v2/payment/revoke/${id}/refund`,
      "POST",
      null,
      (response) => {

        console.log("Success:", response);
        setRefundOrderId("");
        setRefundOrderAmount("");
        setRefundReason("");
        toastr.success("Refund Processed!");
        navigate(-1);
        fetchOrderStatus();
      },
      (err) => {

        console.log("Error:", err);

      },

    );
  };


  return (
    <OrderRefundComponent
      loading={loading}
      orderRefundApi={orderRefundApi}
      refundOrderId={refundOrderId}
      refundOrderAmount={refundOrderAmount}
      handleRefundOrderId={handleRefundOrderId}
      handleRefundOrderAmount={handleRefundOrderAmount}
      handleKeyPress={handleKeyPress}
      refundReason={refundReason}
      handleRefundReason={handleRefundReason}
      pgName={pg_name}
      source={source}
      refundSource={refundSource}
      handleRefundSourceChange={handleRefundSourceChange}
      orderStatus={orderStatus}
      handleRevoke={handleRevok}
      historyData={historyData}
      toggleHistory={toggleHistory}
      setShowHistory={setShowHistory}
      showHistory={showHistory}
    />
  );
};

function mapStateToProps({ props }) {
  return {
    props,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
  setLoading,
})(OrdersRefundContainer);